export const manwithvanManifest = {
    id: 'manwithvan',
    name: 'Man with a Van',
    description: 'Hourly van and driver hire — choose your vehicle',
    version: '1.1.0',
    icon: 'Truck',
    dependencies: ['maps', 'payments'],
    compatibleVehicles: ['van_s', 'van_m', 'van_l', 'van_xl', 'luton'],
    allowedRoles: ['customer', 'driver', 'admin'],
    supportsB2B: false,
    pricing: {
        configurable: true,
        fields: [
            { key: "vatRate", type: "percentage", label: "VAT Rate", hint: "UK VAT percentage applied to all charges", format: "percent", defaultValue: 0, min: 0, max: 100 },
            { key: 'vehicleHourlyRates.van_s', type: 'money', label: 'Small Van (SWB) — Hourly Rate', hint: 'Hourly rate for small van (in pence)', format: 'pence', defaultValue: 2500, required: true },
            { key: 'vehicleHourlyRates.van_m', type: 'money', label: 'Medium Van (MWB) — Hourly Rate', hint: 'Hourly rate for medium van (in pence)', format: 'pence', defaultValue: 3000, required: true },
            { key: 'vehicleHourlyRates.van_l', type: 'money', label: 'Large Van (LWB) — Hourly Rate', hint: 'Hourly rate for large van (in pence)', format: 'pence', defaultValue: 3500, required: true },
            { key: 'vehicleHourlyRates.van_xl', type: 'money', label: 'XL Van — Hourly Rate', hint: 'Hourly rate for XL van (in pence)', format: 'pence', defaultValue: 4000, required: true },
            { key: 'vehicleHourlyRates.luton', type: 'money', label: 'Luton Van — Hourly Rate', hint: 'Hourly rate for Luton van (in pence)', format: 'pence', defaultValue: 5000, required: true },
            { key: 'minHours', type: 'number', label: 'Minimum Hours', hint: 'Minimum booking duration in hours', format: 'number', defaultValue: 2, min: 1, max: 4 },
            { key: 'fuelSurchargePerMile', type: 'money', label: 'Fuel Surcharge per Mile', hint: 'Additional charge per mile to cover fuel (in pence)', format: 'pence', defaultValue: 50 },
            { key: 'helperRate', type: 'money', label: 'Additional Helper per Hour', hint: 'Rate for an extra helper per hour (in pence)', format: 'pence', defaultValue: 1500 },
            { key: 'waitingRate', type: 'money', label: 'Waiting Time per Hour', hint: 'Charge for idle/waiting time per hour (in pence)', format: 'pence', defaultValue: 2500 },
        ],
    },
    features: {
        requiresInventory: false,
        requiresPropertyType: false,
        allowsMultiDrop: true,
        requiresFloorInfo: false,
        hasAssemblyOption: false,
    },
};
//# sourceMappingURL=manifest.js.map